import { getIsServerSide } from './isServerSide';

export type PostMessageAction =
  | 'auth/login-success'
  | 'auth/continue-with-booking'
  | 'auth/resize'
  | 'auth/dismiss'
  | 'auth/esc-key-pressed';

export interface PostMessagePayload {
  action: PostMessageAction;
  payload?: unknown; // Need add correct payload type
}

export const PostMessageActions = {
  LOGIN_SUCCESS: 'auth/login-success',
  CONTINUE_WITH_BOOKING: 'auth/continue-with-booking',
  RESIZE: 'auth/resize',
  DISMISS: 'auth/dismiss',
  ESC_KEY_PRESSED: 'auth/esc-key-pressed',
} as const;

export const sendPostMessage = (message: PostMessagePayload): void => {
  const isServerSide = getIsServerSide();
  if (isServerSide) return;

  window.parent.postMessage(message, '*');
};
